import { gql } from '@apollo/client'

export const CREATE_PROCESSING_MUTATION = gql`
  mutation createProcessing($attributes: ProcessingInput!) {
    createProcessing(attributes: $attributes) {
      id
      acceptedAt
      additionalCost
      agent {
        id
        name
      }
      alternativeProcess
    }
  }
`
